const IPOApplicationStatusPage = () => {
  return <div>IPOApplicationStatusPage</div>;
};

export default IPOApplicationStatusPage;
